import React, { Component } from 'react'
import {reduxForm, Field} from 'redux-form'
import { Row, Col } from 'react-bootstrap'
import { Delete, Launch, Print, AddCircleOutline } from '@material-ui/icons'
import InputCheckBox from '../comun/form/InputCheckBox'
import {permisos as permisosConstant} from '../../constants/permisos'

class FiltrosAlimentacion extends Component {
   constructor () {
    super()
    this.state = {
      openFiltros: false,
      imputSelected: false,
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.fichaVerraco.checkedFiltrosAlimentacion !== prevProps.fichaVerraco.checkedFiltrosAlimentacion) {
      if (this.props.fichaVerraco.checkedFiltrosAlimentacion === false) {
        this.props.change('seleccionar-todo-alimentacion', false)
      }
    }
  }

  abrirFiltros = (event) => {
    this.setState({ openFiltros: true })
  }

  cerrarFiltros = (event) => {
    this.setState({ openFiltros: false })
  }

  intercambiarCheck = (value) => {
    this.setState({ imputSelected: value })
    if (value === true) {
      this.props.actions.seleccionarTodosAlimentacion()
    } else {
      this.props.actions.deSeleccionarTodosAlimentacion()
    }
  }

  deleteSeleccionAlimentacion(){
    const itemsSeleccion = this.props.fichaVerraco.alimentacionAnadidas.map((row) => {
      return this.props.formSimpleTable.values['check' + row.idElemento] === true && (
        {
          'check': this.props.formSimpleTable.values['check' + row.idElemento],
          'idElemento': row.idElemento
        }
      )
    })

    let list = itemsSeleccion.filter(function (item) {
      return item.check === true;
    });
    this.props.actions.deleteSeleccionAlimentacion(list)
    this.props.change('seleccionar-todo-alimentacion', false)
  }

  crearCsvAlimentacion(){
    this.props.actions.crearCsvAlimentacion(this.props.list)
  }

  render () {
  const {
    t,
    actions: { abrirModalVacioAlimentacion }
  } = this.props

  return (
      <div>
        <Row className="acciones-tabla-filtros">
          <Col sm={6}>
            <div className="buttons-flex">
              {(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.FICHA_VERRACOS] > 1) && [
                <div className="custom-check-w" key="custom-check-w">
                  <Field
                    id="seleccionar-todo-alimentacion"
                    name="seleccionar-todo-alimentacion"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    onInputChange={(value) => this.intercambiarCheck(value)}
                  />
                </div>,
                <div id="block-options" key="block-options" className={this.state.imputSelected === true ? 'button-group buttons-min block-options' : 'button-group buttons-min block-options oculta-action'}>
                  <button type="button" data-toggle="modal" data-target="#delete-modal" className="btn btn-icono" onClick={(e) => this.deleteSeleccionAlimentacion()}>
                    <Delete></Delete> {t('TITULOS_BOTONES.ELIMINAR')}
                  </button>
                  <div className="barra-buttons-min"></div>
                </div>
              ]}
              <div className="button-group buttons-min">
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#new-edit-modal-alimentacion"
                  className={"btn btn-primary nuevo" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.FICHA_VERRACOS] < 2) ? ' disabled' : '')}
                  onClick={(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.FICHA_VERRACOS] > 1) ? abrirModalVacioAlimentacion : undefined}
                >
                  <AddCircleOutline></AddCircleOutline> {t('TITULOS_BOTONES.NUEVO')}
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default (reduxForm({
  form: 'FiltrosAlimentacion',
})(FiltrosAlimentacion))
